// Export CSV in coda sul backend, seguiti dal pannello di avanzamento (CsvExportsPanel).
// Sopravvivono al ricaricamento: la lista sta in localStorage finché l'utente non la chiude.
// Una lista per tenant e utente: chi entra dopo sullo stesso browser non vede quelle di un altro.
import Vue from 'vue'
import { safeLocalStorageSet } from '@/services/local-storage-safe'

let storageKey = null

export const csvExports = Vue.observable({ items: [] })

// scope: tenant e utente collegati, null dopo il logout
export function loadCsvExports(scope) {
	storageKey = scope ? 'csv_exports_' + scope : null
	let saved = null
	try {
		saved = storageKey && JSON.parse(localStorage.getItem(storageKey))
	} catch (e) {
		saved = null
	}
	csvExports.items = Array.isArray(saved) ? saved : []
}

export function saveCsvExports() {
	if (storageKey) {
		safeLocalStorageSet(storageKey, JSON.stringify(csvExports.items))
	}
}

// entry: {id, title, total}
export function trackCsvExport(entry) {
	csvExports.items.push({ ...entry, status: 'queued', done: 0, attachment_id: null, file_name: null })
	saveCsvExports()
}

export function dismissCsvExport(id) {
	csvExports.items = csvExports.items.filter(item => item.id !== id)
	saveCsvExports()
}
